import {CommonModule} from "@angular/common";
import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {ProjectService, TreeService} from "@wms/services";
import {WmsWorkspaceManagerService} from "@wms/workspace";
import {sendToAIStudio, StudioUtils} from '@wms/core'
import {EventManagerService} from "@wms/app";

@Component({
  selector: 'wms-studio-ai-workspace',
  templateUrl: './studio-ai-workspace.component.html',
  styleUrls: ['./studio-ai-workspace.component.less'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class StudioAIWorkspaceComponent implements OnInit {
  safeIframeUrl: SafeResourceUrl;
  //theiaUrl: string = 'https://ai-poc-studio.wavemakeronline.com/theia/#/home/project/vol-b4a36861-f487-4a50-8f52-adb0bd4a7961/WaveMaker-Studio/workspace/default/projects/BrightBank/master';

  // aiStudioUrl: string = 'http://localhost:3000/#/Users/bandhavyav_500043/Downloads/BrightBank%20(1)';

  protected projectDetails: any;
  protected aiStudioUrl: string ;
  messageListener?: (event: MessageEvent) => void;

  constructor(private sanitizer: DomSanitizer,private cdRef: ChangeDetectorRef, private projectService: ProjectService, private treeService: TreeService, private eventManager: EventManagerService, private wsManager: WmsWorkspaceManagerService) {
    const localStorageUrl = localStorage.getItem('ai-studio-url');

    //@ts-ignore
    if(!StudioUtils.projectDetails) {
      //check this again. This is required to initialize when the user directly access the AI Studio
      StudioUtils.init();
    }

    if(localStorageUrl) {
      this.aiStudioUrl = localStorageUrl;
      this.updateIframeSrc(localStorageUrl);
      return;
    }

    this.projectDetails = this.projectService.getDetails();
    if(this.projectDetails) {
      this.updateIframeSrc(this.projectDetails.aiStudioUrl);
      return
    }

    if (!this.projectDetails) {
        this.projectService.loadDetails().then((response)=>{
          this.projectDetails = response;
          this.updateIframeSrc(this.projectDetails.aiStudioUrl);
          this.cdRef.detectChanges();
        })
      }

  }

  ngOnInit() {
    this.initializeAIStudioMessageListeners();
    const iframe = document.getElementById('embededTheia');
  }

  handleStorageEvent(event: StorageEvent) {
    if (event.key === 'ai-studio-url') {
      console.log('url ...', event.newValue);
      event.newValue && this.updateIframeSrc(event.newValue);
    }
  }

  updateIframeSrc(aiStudioUrl: string) {
    let url = aiStudioUrl;
    this.safeIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(aiStudioUrl);
  }

  initializeAIStudioMessageListeners(): void {
    this.messageListener = (event: MessageEvent) => {
      if(event.data.source === 'wm-ai-studio') {
        console.log('[WM Studio] - Message from WM AI Studio', event.data);
        switch (event.data.type) {
          case 'messaging-service-ready':
            console.log('[WM Studio] - WM AI Studio Messaging service is ready', event.data);
            let defaultActiveWS = {
              details: {id: 'PAGE', displayName: 'Pages', icon: 'page', match: '/page/', pageName: 'Main', tab: "DESIGN"},
              identifier: "PAGE:Main",
              name: "Main",
              type:"PAGE"
            };
            let metadata = {workspace: this.wsManager.activeWS ? this.wsManager.activeWS : defaultActiveWS}
            //fix this later. It should be fixed in the style workspace - style.component
            metadata.workspace = this.wsManager.activeWS?.details ? this.wsManager.activeWS : this.wsManager.activeWS?.meta;
            if(this.wsManager.serviceClassesMetaData) {
              //@ts-ignore
              metadata["serviceClasses"] = this.wsManager.serviceClassesMetaData;
            }
            sendToAIStudio(metadata);
            this.wsManager.setMessageServiceReady(true);
            break;
          case 'change-set':
            this.eventManager.pushToStudioRefreshQueue(event.data.data.files);
            break;
          default:
            console.log('Unknown message type:', event.data.type, event);
        }
      }
    }
    window.addEventListener('message', this.messageListener);
    console.log('[WM Studio] - WM AI Studio message listener initialized');
  }

}
